import { render } from "./OrderLayout.vue?vue&type=template&id=7c7da106&scoped=true&ts=true"
import script from "./OrderLayout.vue?vue&type=script&lang=ts"
export * from "./OrderLayout.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c7da106"]])

export default __exports__